document.addEventListener("DOMContentLoaded", function() {
  // Sticky header functionality
  window.addEventListener("scroll", function() {
    if (window.scrollY > 1) {
      document.querySelector(".main-nav").classList.add("sticky");
    } else {
      document.querySelector(".main-nav").classList.remove("sticky");
    }
  });

  // Initialize HC Off-canvas Nav
  if (typeof jQuery !== 'undefined' && jQuery('#main-nav').length) {
    jQuery(function($) {
      $('#main-nav').hcOffcanvasNav({
        disableAt: 1024,
        customToggle: $('.toggle-button'),
        navTitle: 'Menu',
        insertClose: false,
        navTitle: '',  
        navClass: 'g39-offcanvas-nav',
        levelTitles: false,
        levelTitleAsBack: false,
        labelBack: '',
      });
    });
  }
});